import React from "react";
import Forbidden from "../pages/Forbidden";
import ForgotPassword from "../pages/ForgotPassword";
import InternalServerError from "../pages/InternalServerError";
// import LockScreen from "../pages/LockScreen";
import NotFound from "../pages/NotFound";
import ServiceUnavailable from "../pages/ServiceUnavailable";
// import Signin from "../pages/Signin";
// import Signin2 from "../pages/Signin2";
import Signin3 from "../pages/Signin3";
import NewPassword from "../pages/NewPassword";
// import Signup from "../pages/Signup";
// import Signup2 from "../pages/Signup2";
// import VerifyAccount from "../pages/VerifyAccount";
//import IoTComponent from "../pages/Iotcomponent"; using aws

const publicRoutes = [
   // { path: "pages/signin", element: <Signin /> },
   // { path: "pages/signin2", element: <Signin2 /> },
   { path: "pages/signin3", element: <Signin3 /> },
   { path: "pages/newpassword", element: <NewPassword /> },
   { path: "pages/forgotpassword", element: <ForgotPassword /> },
   // { path: "pages/signup", element: <Signup /> },
   // { path: "pages/signup2", element: <Signup2 /> },
   //{ path: "pages/test", element: <IoTComponent /> },
   // { path: "pages/verify", element: <VerifyAccount /> },
   // { path: "pages/lock", element: <LockScreen /> },
   { path: "pages/error-404", element: <NotFound /> },
   { path: "pages/error-500", element: <InternalServerError /> },
   { path: "pages/error-503", element: <ServiceUnavailable /> },
   { path: "pages/error-505", element: <Forbidden /> },
];

export default publicRoutes;
